// extracted by mini-css-extract-plugin
export default {"title":"ProductInfo_title__ACFA8","description":"ProductInfo_description__6nA2E","price":"ProductInfo_price__RFPTB"};